/**
 * Page View and Other Event depends on each other. eVar and Prop value set on page view events are also sent in subsequent events.
 * Hence, it is important to populate all the needed data in page view event.
 */

const LOB = 'domestic cabs';
const PAGE_NAME_PREFIX = 'funnel:domestic cabs:';
const CHANNEL = 'domestic cabs funnel';

export const PROVISIONAL_HOB_OVERLAY_PAGE_LANDING  = 'hob kiosk provisonal landing overlaypage'
export const PROVISIONAL_HOB_OVERLAY_PAGE_LISTING  = 'hob kiosk provisonal listing overlaypage'
export const PROVISIONAL_HOB_OVERLAY_PAGE_THANKYOU =  'hob kiosk provisonal thankyou overlaypage'
// pokus keys whose values should be send to omniture

const events: Array<[string, Record<string, string>]> = [];

export function trackPageView(pageName: string, data: Record<string, unknown> = {}) {

  const eventPageName = `${PAGE_NAME_PREFIX}${pageName}`;

  try {
    // @ts-ignore
    const { s } = window;
    if (!s) {
      retryEvent(pageName, '', data);
      return;
    }
    // common events
    s.events = 'scOpen,event11,event30,prodView,event325';
    s.pageName = eventPageName;
    s.eVar1 = 'PWA_RNW';
    s.eVar15 = eventPageName;
    s.channel = CHANNEL;
    s.eVar24 = LOB;
    s.eVar75 = 'PWA_RNW_Direct';
    s.eVar61 = 'en';
    s.prop24 = LOB;
    s.eVar39 = 'Guest';

    Object.keys(data).forEach((key) => {
      s[key] = data[key];
    });

    //@ts-ignore
    s.t();

  } catch (err) {
    console.log(err);
  }
}

export function trackEvent(pageName: string, eventName: string, data: Record<string, unknown> = {}) {
  try {
    // @ts-ignore
    const s: any = window.s;

    const _pageName = `${PAGE_NAME_PREFIX}${pageName}`;
    if (!s) {
      retryEvent(_pageName, eventName, {}, false);
      return;
    }
    s.linkTrackVars = 'channel,eVar1,eVar15,eVar24,eVar34,prop24,prop54,eVar75,eVar47,eVar13,eVar22';
    s.prop54 = eventName;

    Object.keys(data).forEach((key) => {
      s[key] = data[key];
    });
    // @ts-ignore
    s.tl(this, _pageName, eventName);
  } catch (error) {
    console.log(error);
  }
}

function retryEvent(pageName: string, eventName: string, data: Record<string, unknown>, isPageView = true) {
  setTimeout(() => {
    if (isPageView) {
      trackPageView(pageName, data);
    } else {
      trackEvent(pageName, eventName);
    }
  }, 1500);
}